import Alpine from 'alpinejs';

import maskPlugin from '@alpinejs/mask';
import persistPlugin from '@alpinejs/persist';

import indicator from '../main/mixins/indicator';
import lead from '../main/mixins/lead';
import phone from '../main/mixins/phone';

window.Alpine = Alpine;

Alpine.plugin(maskPlugin);
Alpine.plugin(persistPlugin);

Alpine.data('indicator', indicator);
Alpine.data('lead', lead);
Alpine.data('phone', phone);

Alpine.start();
